import {
  CLEAN_CONSULTINGCHECKZIPCODE,
  CLEAN_CONSULTINGCHECKZIPCODE_ERROR,
  CONSULTINGCHECKZIPCODE,
  CONSULTINGCHECKZIPCODE_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function consultingCheckZipcodeReducer(state = initialState, action) {
  switch (action.type) {
    case CONSULTINGCHECKZIPCODE:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case CONSULTINGCHECKZIPCODE_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };
    case CLEAN_CONSULTINGCHECKZIPCODE:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_CONSULTINGCHECKZIPCODE_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
